/**
 * Drops the query string and fragment from a URL, keeping origin and path.
 * Why everything rather than a denylist: ADR 20261015, "Privacy position".
 *
 * If the URL cannot be parsed, it is cut at the first `?` or `#` instead, so a
 * parse failure still cannot leak a query string. Never throws — a RUM
 * attribute is never worth throwing inside `beforeSend`, which would drop the
 * event entirely.
 */
export const stripUrlQuery = (url: string | undefined): string | undefined => {
  if (!url) {
    return url;
  }

  try {
    const parsed = new URL(url);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    // Relative or malformed URL. Fall back to cutting at the first delimiter so
    // a parse failure still cannot leak a query string.
    return url.split(/[?#]/)[0];
  }
};
